<template>
  <el-container class="home-container">
    <el-header
      :style="{
        background: `url(${vipConfigObj.backgroundImgUrl}) no-repeat center center`,
        backgroundSize: 'cover',
        display: 'flex',
        justifyContent: 'space-between',
        height: '50px',
        width: '100%',
        backgroundPosition: 'center',
      }"
      class="headerBox"
    >
      <div class="logo">
        <img class="logo-img" :src="vipConfigObj.vipImgUrl" alt="">
      </div>
      <div class="account">
        <img src="" alt="">
        <div class="headerRight">
          <el-dropdown class="my-dropdown">
          <span class="el-dropdown-link">
            <!-- 头像 用户名称 -->
            <img class="avatar" :src="vipConfigObj.vipProfileImgUrl" alt />
            <span class="username">{{ name }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <!--  slot="dropdown" 插槽 -->
          <el-dropdown-menu slot="dropdown" v-if="createTenantCode">
            <el-dropdown-item
              icon="el-icon-edit-outline"
              @click.native="setting()"
              >修改密码</el-dropdown-item
            >
            <el-dropdown-item icon="el-icon-unlock" @click.native="logoutV2()"
              >退出登录</el-dropdown-item
            >
            <!-- <el-dropdown-item icon="el-icon-school" v-if="tenantList.length>1" @click.native="orgChange()">切换仓库</el-dropdown-item> -->
          </el-dropdown-menu>
          <el-dropdown-menu slot="dropdown" v-else>
            <el-dropdown-item
              icon="el-icon-edit-outline"
              @click.native="setting()"
              >修改密码</el-dropdown-item
            >
            <el-dropdown-item icon="el-icon-unlock" @click.native="logout()"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        </div>
      </div>
    </el-header>
    <!-- <el-header
      height="46px"
      style="display:flex;justify-content: space-between;"
    >
      <div style="display:flex;align-items: center;">
        <span class="text">{{ tenantName }}</span>
        <span style="color:#fff;" v-if="tenantList.length > 1"
          >（{{ createTenantName }}）</span
        >
      </div>
      <div class="headerRight">
        <el-dropdown class="my-dropdown">
          <span class="el-dropdown-link">
            头像 用户名称
            <img class="avatar" src="../../../assets/images/loginer.png" alt />
            <span class="username">{{ name }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
           slot="dropdown" 插槽
          <el-dropdown-menu slot="dropdown" v-if="createTenantCode">
            <el-dropdown-item
              icon="el-icon-edit-outline"
              @click.native="setting()"
              >修改密码</el-dropdown-item
            >
            <el-dropdown-item icon="el-icon-unlock" @click.native="logoutV2()"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
          <el-dropdown-menu slot="dropdown" v-else>
            <el-dropdown-item
              icon="el-icon-edit-outline"
              @click.native="setting()"
              >修改密码</el-dropdown-item
            >
            <el-dropdown-item icon="el-icon-unlock" @click.native="logout()"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header> -->
    <el-container>
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <!-- logo -->
        <!-- <div class="logo" :class="{miniLogo:isCollapse}"></div> -->
        <!-- 导航菜单 -->
        <!-- default-active="/" 根据当路径来设置 this.$route.path -->
        <!-- this.$route 获取路由数据  this.$router 调用路由函数 -->
        <!-- 获取地址栏传参：user?id=100  this.$route.query.id  /user/100 this.$route.params.id  -->
        <div class="menuBox" v-if="createTenantCode">
          <el-menu
            :default-active="$route.path"
            class="el-menu-vertical-demo"
            background-color="#001529"
            text-color="#fff"
            :collapse="isCollapse"
            :collapse-transition="false"
            router
          >
            <template v-for="item in menuList">
              <template v-if="!item.childMenu">
                <!-- 一级菜单（没有任何子级菜单）-->
                <el-menu-item
                  :index="item.accessUrl"
                  :route="item.accessUrl + '?menuOrBtnId=' + item.id"
                  :key="item.id"
                >
                  <i :class="item.picName"></i
                  ><span slot="title">{{ item.name }}</span>
                </el-menu-item>
              </template>
              <template v-else>
                <!-- 一级菜单（有子级菜单）-->
                <el-submenu :index="item.id + ''" :key="item.id">
                  <template slot="title">
                    <i :class="item.picName"></i
                    ><span slot="title">{{ item.name }}</span>
                  </template>
                  <!-- 遍历二级菜单容器 -->
                  <template v-for="i in item.childMenu">
                    <!-- 判断二级菜单（没有三级菜单）-->
                    <template v-if="!i.childMenu">
                      <el-menu-item
                        :index="i.accessUrl"
                        :route="i.accessUrl + '?menuOrBtnId=' + i.id"
                        :key="i.id"
                        >{{ i.name }}</el-menu-item
                      >
                    </template>
                    <template v-else>
                      <!-- 判断二级菜单（有三级菜单）-->
                      <el-submenu :index="i.id + ''" :key="i.id">
                        <template slot="title">
                          <span slot="title">{{ i.name }}</span></template
                        >
                        <template v-for="j in i.childMenu">
                          <el-menu-item
                            :index="j.accessUrl"
                            :route="j.accessUrl + '?menuOrBtnId=' + j.id"
                            :key="j.id"
                            >{{ j.name }}</el-menu-item
                          >
                        </template>
                      </el-submenu>
                    </template>
                  </template>
                </el-submenu>
              </template>
            </template>
          </el-menu>
        </div>
        <div class="menuBox" v-else>
          <el-menu
            :default-active="$route.path"
            class="el-menu-vertical-demo"
            background-color="#001529"
            text-color="#fff"
            :collapse="isCollapse"
            :collapse-transition="false"
            router
          >
            <template v-for="(item, index) in menuList">
              <template v-if="item.childMenu.length > 0">
                <el-submenu :index="index + ''" :key="index">
                  <template slot="title">
                    <i :class="item.picname"></i>
                    <span slot="title">{{ item.menufuncName }}</span>
                  </template>
                  <el-menu-item
                    v-for="item in item.childMenu"
                    :index="item.menufuncIp"
                    :key="item.menufuncIp"
                  >
                    <i :class="item.picname"></i>
                    <span slot="title">{{ item.menufuncName }}</span>
                  </el-menu-item>
                </el-submenu>
              </template>
              <template v-else>
                <el-menu-item :index="item.menufuncIp" :key="item.menufuncIp">
                  <i :class="item.picname"></i>
                  <span slot="title">{{ item.menufuncName }}</span>
                </el-menu-item>
              </template>
            </template>
          </el-menu>
        </div>
        <div class="toggleMenuBox">
          <span @click="toggleMenu()" class="icon el-icon-s-fold"></span>
        </div>
      </el-aside>
      <el-main>
        <!-- 二级路由对应组件渲染位置 -->
        <router-view v-if="!$route.meta.keepAlive" @msgFn="msgFn"></router-view>
        <keep-alive v-if="isRouterAlive">
          <router-view
            v-if="$route.meta.keepAlive"
            style="min-height:100%"
            @msgFn="msgFn"
          ></router-view>
        </keep-alive>
      </el-main>
      <el-dialog
        title="修改密码"
        :visible.sync="changePawDialog"
        width="420px"
        center
        @close="closeDialog"
        class="inpBox jiaoyan"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="changePaw"
          status-icon
          :rules="rules"
          ref="changePaw"
          label-width="150px"
          class="demo-ruleForm"
          size="mini"
        >
          <el-form-item label="旧密码" prop="passwordOld">
            <el-input
              type="password"
              v-model="changePaw.passwordOld"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="passwordNew">
            <el-tooltip class="item" effect="dark" content placement="top-end">
              <div slot="content">
                长度为8-16个字符
                <br />包括数字、字母、特殊字符两种或以上
              </div>
              <el-input
                type="password"
                v-model="changePaw.passwordNew"
                autocomplete="off"
                show-password
                maxlength="20"
              ></el-input>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-tooltip class="item" effect="dark" content placement="top-end">
              <div slot="content">
                长度为8-16个字符
                <br />包括数字、字母、特殊字符两种或以上
              </div>
              <el-input
                type="password"
                v-model="changePaw.checkPass"
                autocomplete="off"
                show-password
                maxlength="20"
              ></el-input>
            </el-tooltip>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('changePaw')"
              >提交</el-button
            >
            <el-button @click="resetForm('changePaw')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-container>
    <!-- <el-dialog title="账号绑定" :visible.sync="boundIDVisible" width="70%" center @close="boundIDVisible = false" :close-on-click-modal="false">
      <el-button type="primary" @click="addID">新建</el-button>
      <div style="margin-top:10px">
        <el-table border center size="mini" :data="tableData" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row height="300">
          <el-table-column label="操作" width="180">
            <template v-slot='scope'>
              <el-button type="text" @click="changeRow(scope.row)">修改</el-button>
              <el-button type="text" @click="deleteRow(scope.row)">删除</el-button>
              <el-button type="text" @click="bindRow(scope.row)" v-if="scope.row.twoway_bind == 1">授权互绑</el-button>
              <el-button type="text" @click="JCbindRow(scope.row)" v-if="scope.row.twoway_bind == 2">解除互绑</el-button>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="账号" prop="user_account"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="互绑状态" prop="twoway_bind">
            <template v-slot='scope'>
              <span v-if="scope.row.twoway_bind==1">未互绑</span>
              <span v-else>已互绑</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="用户名称" prop="user_name"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="租户名称" prop="tenant_name"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="绑定时间" prop="create_time" :formatter="dateTimeFormat"></el-table-column>
        </el-table>
      </div>
    </el-dialog> -->
    <!-- <el-dialog :title="addTitle" :visible.sync="addVisible" width="35%" center @close="addVisible = false" class="boundStyle" :close-on-click-modal="false">
      <el-form size="mini" ref="formData" label-width="150px" :model="formData" style="width: 500px; margin: 15px auto" :rules="Rules">
        <el-form-item label="登录账号：" prop="userAccount">
          <el-input size="mini" style="width:215px;" v-model="formData.userAccount" autocomplete='new-password' @change="userChange"></el-input>
        </el-form-item>
        <el-form-item label="登录密码：" prop="userPwd" style="position:relative">
          <el-input size="mini" style="width:215px;" v-model="formData.userPwd" @blur="userPwdJY(formData.userPwd)" type="password" autocomplete='new-password'></el-input>
          <span style="color:red;margin-left:5px;font-size:26px;position:absolute;" v-if="PwdShow">×</span>
          <span style="color:green;margin-left:5px;font-size:26px;position:absolute;" v-else>√</span>
        </el-form-item>
        <el-form-item label="用户名称：" prop="username">
          <el-input size="mini" style="width:215px;" v-model="formData.username" disabled></el-input>
        </el-form-item>
        <el-form-item label="租户名称：" prop="tenantName">
          <el-input size="mini" style="width:215px;" v-model="formData.tenantName" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" prop="mobile">
          <el-input size="mini" style="width:120px;" v-model="formData.mobile" @blur="shoujiBlur(formData.mobile)" disabled></el-input>
          <el-button type="primary" size="mini" style="margin-left:5px" @click="sendNumber" v-if="isShowGetCode">发送验证码</el-button>
          <span v-else class="identiCode cancel-pointer" style="margin-left:5px">{{ countdown }}s后可重试</span>
        </el-form-item>
        <el-form-item label="验证码：" prop="checkCode">
          <el-input size="mini" style="width:215px;" v-model="formData.checkCode"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="addIDVisible">确 定</el-button>
      </span>
    </el-dialog> -->
  </el-container>
</template>

<script>
import store from '@/store'
import {
  receiveMsgNoReadList,
  receiveMsgNoReadSum,
  loginUserV2
} from '@/api/common'
import { BindAccountList, getFindByLoginTenantCode } from '@/api/newCrm'
import { encryption, dateTimeFormat } from '@/utils/util'
export default {
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.changePaw.passwordNew) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      dateTimeFormat,
      // tenantName:'',
      isCollapse: false,
      name: localStorage.getItem('userName'),
      menuList: [],
      changePawDialog: false,
      changePaw: {
        passwordOld: '',
        passwordNew: '',
        checkPass: ''
      },
      tenantName: localStorage.getItem('tenantName'),
      rules: {
        passwordOld: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        passwordNew: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 8, message: '请输入至少8位的密码', trigger: 'blur' },
          // eslint-disable-next-line no-useless-escape
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z-`=\[\];',.~!@#$%^&*()_+|{}:"?]{8,16}$/,
            message: '密码设置不符合要求'
          }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' },
          { min: 8, message: '请输入至少8位的密码', trigger: 'blur' },
          // eslint-disable-next-line no-useless-escape
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z-`=\[\];',.~!@#$%^&*()_+|{}:"?]{8,16}$/,
            message: '密码设置不符合要求'
          }
        ]
      },
      msgNum: 0,
      timeInterval: '600000', // 消息定时器时长
      tiemr: null,
      notifyPromise: Promise.resolve(),
      createTenantCode: localStorage.getItem('createTenantCode'),
      createTenantName: localStorage.getItem('createTenantName'),
      tenantList: [],
      isRouterAlive: true,
      boundIDVisible: false,
      tableData: [],
      addTitle: '',
      addVisible: false,
      formData: {},
      PwdShow: true,
      phone: '',
      bindUserId: '',
      changeData: [],
      isShowGetCode: true,
      countdown: 60,
      timer: '',
      Rules: {
        userAccount: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        userPwd: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        tenantName: [
          { required: true, message: '请输入租户名称', trigger: 'blur' }
        ],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        checkCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      headerBackground: require('../../../assets/images/vipBg.png'),
      vipConfigObj: {}
    }
  },
  provide () {
    return { reload: this.reload }
  },
  created () {
    this.getTree()
    // 切换账号
    // this.BindAccountList()
    this.getLoginUserGradeInfo()
  },
  methods: {
    getLoginUserGradeInfo () {
      const params = {
        tenantCode: localStorage.getItem('tenantCode')
      }
      getFindByLoginTenantCode(params).then(res => {
        if (res) {
          this.vipConfigObj = res
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getTree () {
      if (localStorage.getItem('tenantList')) {
        this.tenantList = JSON.parse(localStorage.getItem('tenantList'))
      }
      // this.getMsg()
      // this.tiemr = setInterval(this.getMsg, this.timeInterval)
      // if (localStorage.getItem('isCutCrm3') == 1) {
      console.log(this.createTenantCode)
      if (this.createTenantCode) {
        document.title = this.tenantName
        const loading = this.$loading({
          lock: true,
          text: '正在加载...'
        })
        let params = {}
        if (localStorage.getItem('isBusiness') == 1) {
          params = { businessId: localStorage.getItem('createTenantCode') }
        } else {
          params = { tenantCode: localStorage.getItem('createTenantCode') }
        }
        this.$axios({
          method: 'post',
          url: this.global.commonNameV2 + '/user/rightTree',
          params: params
        })
          .then((res) => {
            loading.close()
            localStorage.setItem('menuList', res.data)
            this.menuList = JSON.parse(res.data)
            let menuList = JSON.parse(res.data)
            if (!store.getIp()) {
              if (menuList[0].childMenu) {
                // 判断一级下面有没有二级
                if (menuList[0].childMenu[0].childMenu) {
                  // 判断二级下面有没有子集
                  store.setIp(
                    menuList[0].childMenu[0].childMenu[0].accessUrl +
                      '?menuOrBtnId=' +
                      menuList[0].childMenu[0].childMenu[0].id
                  )
                  this.$router.push({
                    path: menuList[0].childMenu[0].childMenu[0].accessUrl,
                    query: {
                      menuOrBtnId: menuList[0].childMenu[0].childMenu[0].id
                    }
                  })
                } else {
                  store.setIp(
                    menuList[0].childMenu[0].accessUrl +
                      '?menuOrBtnId=' +
                      menuList[0].childMenu[0].id
                  )
                  this.$router.push({
                    path: menuList[0].childMenu[0].accessUrl,
                    query: { menuOrBtnId: menuList[0].childMenu[0].id }
                  })
                }
              } else {
                // 一级下面没有子菜单
                store.setIp(
                  menuList[0].accessUrl + '?menuOrBtnId=' + menuList[0].id
                )
                this.$router.push({
                  path: menuList[0].accessUrl,
                  query: { menuOrBtnId: menuList[0].id }
                })
              }
            }
            // menuList.forEach(item => {
            //   if (item.childMenu) { // 判断一级下面有没有二级
            //     item.childMenu.forEach(i => {
            //       if (i.childMenu) { // 判断二级下面有没有子集
            //         i.childMenu.forEach(j => {
            //           setBtnFn(j)
            //         })
            //       } else {
            //         setBtnFn(i)
            //       }
            //     })
            //   } else { // 一级下面没有子菜单
            //     setBtnFn(item)
            //   }
            // })
            // function setBtnFn (data) {
            //   if (data.buttonDetails.length > 0) {
            //     localStorage.setItem(data.accessUrl, JSON.stringify(data.buttonDetails))
            //   }
            // }
          })
          .catch((error) => {
            this.$message.error(error.msg)
          })
      } else {
        this.orgChange()
      }
      // } else {
      //   this.loginUserV2()
      // }
    },
    loginUserV2 () {
      loginUserV2().then((res) => {
        document.title = res.tenantName
        localStorage.setItem('mobile', res.mobile)
        localStorage.setItem('userCode', res.userCode)
        localStorage.setItem('userName', res.userName)
        localStorage.setItem('tenantName', res.tenantName)
        localStorage.setItem('tenantCode', res.tenantCode)
        localStorage.setItem('registerId', res.userId)
        localStorage.setItem('businessFlg', res.businessFlg)
        localStorage.setItem('tenantTaxpayerNumber', res.tenantTaxpayerNumber)
        localStorage.setItem('isAdmin', res.isAdmin)
        this.tenantName = localStorage.getItem('tenantName')
        this.name = localStorage.getItem('userName')
        if (res.businessList) {
          res.businessList.forEach((item) => {
            res.tenantList.push({
              tenantCode: item.businessId,
              businessCode: item.businessCode,
              tenantName: item.businessName,
              flag: true
            })
          })
        }
        if (res.tenantList.length == 1) {
          localStorage.setItem(
            'isBusiness',
            res.businessList && res.businessList.length == 1 ? 1 : 2
          )
          localStorage.setItem('createTenantCode', res.tenantList[0].tenantCode)
          localStorage.setItem('createTenantName', res.tenantList[0].tenantName)
        } else if (res.tenantList.length > 1) {
          localStorage.setItem('tenantList', JSON.stringify(res.tenantList))
          this.$router.push({ path: '/selectOrg' })
        } else {
          this.$message.error('该账号无操作权限！')
        }
        this.createTenantCode = localStorage.getItem('createTenantCode')
        this.getTree()
        BindAccountList()
          .then((res) => {
            console.log(res)
            this.changeData = res
          })
          .catch((error) => {
            this.$message.error(error.message)
          })
      })
    },
    BindAccountList () {
      BindAccountList()
        .then((res) => {
          console.log(res)
          this.changeData = res
        })
        .catch((error) => {
          this.$message.error(error.message)
        })
    },
    // 切换账号
    changeID (val) {
      this.$confirm('确认切换账号吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then((res) => {
          console.log(store.getUser(), 'store.getUser()')
          this.$axios({
            headers: {
              Authorization: 'Bearer ' + store.getUser().access_token
            },
            method: 'post',
            url: this.global.commonNameV2 + '/oauth/token',
            params: {
              grant_type: 'cut_account',
              bindUserId: val
            }
          })
            .then((res) => {
              console.log(res)
              store.delUser()
              store.setUser(res.data)
              localStorage.clear()
              sessionStorage.clear()
              localStorage.setItem('isCutCrm3', res.data.isCutCrm3)
              this.loginUserV2()
            })
            .catch((error) => {
              this.$message.error(error.message)
            })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    boundID () {
      this.boundIDVisible = true
    },

    // 解决keep-alive缓存问
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    },
    // 切换仓库
    orgChange () {
      this.$router.push({ path: '/selectOrg' })
    },
    msgFn (data) {
      this.msgNum = data
    },
    getMsg () {
      receiveMsgNoReadList({
        timeInterval: this.timeInterval,
        userType: 1
      }).then((res) => {
        res.forEach((item) => {
          this.notify(item)
        })
      })
      receiveMsgNoReadSum({
        userType: 1
      }).then((res) => {
        this.msgNum = res
      })
    },
    notify (item) {
      let that = this
      this.notifyPromise = this.notifyPromise.then(this.$nextTick).then(() => {
        this.$notify({
          title: item.messageTitle,
          // dangerouslyUseHTMLString: true,
          //  message: item.messageContent,
          position: 'bottom-right',
          onClick: function () {
            that.$router.push({ name: 'messageLook', query: { id: item.id } })
          }
        })
      })
    },
    xiaoxiFn () {
      this.$router.push('/messageNotification')
    },
    // el-dropdown-item 绑定事件  不支持click
    // 当你给组件绑定事件的时候，如果组件没有支持这个事件，当然不会触发。
    // click是原生dom拥有的事件，目的给组件渲染后的dom绑定事件
    // 事件修饰符，例如 @click.prevent="函数"  阻止默认行为  @click.native 把原生事件绑定在组件上
    // https://cn.vuejs.org/v2/guide/events.html#%E4%BA%8B%E4%BB%B6%E4%BF%AE%E9%A5%B0%E7%AC%A6
    // 消息公告
    // 去设置页面
    getData () {
      return function () {}
    },
    setting () {
      this.changePawDialog = true
    },
    // 回到首页
    goHome () {
      // this.$router.push('/website')
      window.open('http://www.zw56.com')
    },
    // 退出登录
    logout () {
      this.$axios
        .get(this.global.commonName + '/oauth/remove/token')
        .then((res) => {
          store.delUser()
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push('/login')
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    // 退出登录
    logoutV2 () {
      this.$axios
        .get(this.global.commonNameV2 + '/oauth/remove/token')
        .then((res) => {
          store.delUser()
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push('/login')
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    // 修改密码 适用v1和v2
    submitForm (formName) {
      let data = encryption({
        data: this.changePaw,
        key: this.global.key,
        param: ['passwordOld', 'passwordNew']
      })
      let data1 = {
        passwordOld: data.passwordOld,
        passwordNew: data.passwordNew
      }
      let url = ''
      if (this.createTenantCode) {
        // 判断那个版本修改密码
        url = this.global.commonNameV2
      } else {
        url = this.global.commonName
      }
      // console.log(data1)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios({
            method: 'post',
            url: url + '/user/changePwd',
            params: data1
          })
            .then((res) => {
              this.$message('修改密码成功请重新登录')
              this.logout()
            })
            .catch((error) => {
              console.log(error)
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {}
              })
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    toggleMenu () {
      // 切换侧边栏展开与收起
      // 数据 isCollapse 默认值false 展开意思
      // 通过这个数据的状态去切换 侧边栏展开与收起 状态
      this.isCollapse = !this.isCollapse
    },
    closeDialog () {
      this.$refs.changePaw.resetFields()
    }
  },
  destroyed () {
    clearInterval(this.tiemr)
    clearInterval(this.timer)
  }
}
</script>

<style lang="less">
// FE  front end  前端工程师
// el-container 自定义标签是一个组件  渲染后的结构div span section  默认在标签上架上一个和组件名称一致的类名
body {
  background-color: #e5e5e5;
}
.headerBox{
  .logo{
    display: flex;
    align-items: center;
    .logo-img{
      height: 38px;
    }
  }
  .headerRight {
      float: right;
      display: flex;
      .mesbox {
        display: flex;
        margin-right: 8px;
        align-items: center;
      }
      .el-badge__content {
        top: 8px;
        border: none;
      }
      .el-icon-message-solid {
        font-size: 14px;
        margin-right: 4px;
      }
      .avatar {
        width: 30px;
        height: 30px;
        vertical-align: middle;
        display: inline-block;
      }
      .username {
        color: #fff;
        vertical-align: middle;
        font-size: 12px;
        margin-left: 4px;
        cursor: pointer;
      }
      .el-icon-arrow-down {
        color: #fff;
      }
      .ID-dropdown {
        .el-i-down {
          transform: rotate(90deg);
          color: #fff;
          font-size: 14px;
          margin-right: 4px;
        }
        .ID-change {
          color: #fff;
          font-size: 12px;
        }
      }
    }
}
.el-main {
  margin-left: 10px;
  background: #fff;
  padding: 0;
  padding-top: 12px;
}
.searchBtnBox {
  padding-left: 10px;
}
.home-container {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  .el-aside {
    background: #001529;
    position: relative;
    height: calc(100vh - 50px);
    overflow: hidden;
    .menuBox {
      height: calc(100% - 50px);
      overflow: auto;
      padding-bottom: 50px;
    }
    .menuBox::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    .menuBox::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(14, 110, 236, 0.3);
      background: #535353;
    }
    .menuBox::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #ededed;
    }
    // 后面样式覆盖前面
    .miniLogo {
      background-image: url(../../../assets/images/logo_admin_01.png);
      background-size: 36px auto;
    }
    .el-menu {
      border-right: none;
    }
    .el-menu-item {
      height: 46px;
      line-height: 46px;
    }
    .el-submenu .el-menu-item {
      min-width: 100px;
    }
    .el-menu .fa {
      margin-right: 8px;
      color: #fff;
    }
    .el-menu-item,
    .el-submenu__title {
      height: 46px;
      line-height: 46px;
    }

    .submenuBox .el-menu-item {
      background-color: #000c17 !important;
    }
    .el-menu-item.is-active {
      background: #37405E !important;
      color: #fff;
    }
    .el-menu-item:hover {
      background: #465276 !important;
    }
    .submenuBox .el-submenu__title:hover {
      background: #465276 !important;
    }
    .toggleMenuBox {
      text-align: center;
      width: 100%;
      position: absolute;
      color: #fff;
      bottom: 0px;
      padding: 0px 0 20px;
      background: #001529;
    }
  }
  .el-header {
    background-color: #0e6eec;
    line-height: 46px;

    .icon {
      font-size: 24px;
      vertical-align: middle;
      padding-right: 10px;
    }
    .text {
      font-family: Source Han Sans CN;
      font-size: 22px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 37px;
      color: #fff;
    }
    .headerRight {
      float: right;
      display: flex;
      .mesbox {
        display: flex;
        margin-right: 8px;
        align-items: center;
      }
      .el-badge__content {
        top: 8px;
        border: none;
      }
      .el-icon-message-solid {
        font-size: 14px;
        margin-right: 4px;
      }
      .avatar {
        width: 50px;
        height: 50px;
        vertical-align: middle;
        display: inline-block;
      }
      .username {
        color: #fff;
        vertical-align: middle;
        font-size: 12px;
        margin-left: 4px;
        cursor: pointer;
      }
      .el-icon-arrow-down {
        color: #fff;
      }
      .ID-dropdown {
        .el-i-down {
          transform: rotate(90deg);
          color: #fff;
          font-size: 14px;
          margin-right: 4px;
        }
        .ID-change {
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }
}
.el-main {
  height: calc(100vh - 50px);
}
.el-submenu__title i {
  color: #fff;
}

.footerBtn {
  text-align: center;
  margin: 20px;
}
.dialogInp {
  background: #dbe5ef;
  padding: 20px 0;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
}
.diqu1 {
  .el-form-item__content {
    .el-input__inner {
      width: 460px;
    }
  }
}
.jiage .el-form-item__content {
  position: relative;
  .danwei {
    position: absolute;
    right: 4px;
    color: #9c9797;
  }
}

.el-table td,
.el-table th {
  padding: 2px 0 !important;
}
.el-main {
  padding-bottom: 0 !important;
}
.inpBox .el-input__inner {
  width: 150px;
}
.remark .el-input .el-input__inner {
  width: 480px;
}
.gjh {
  height: 60px;
}
.gjh .el-input__inner {
  height: 100%;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 6px;
}
.jiaoyan .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 16px !important;
}
.searchBox {
  display: flex;
}
.searchBox .gjhBox .el-form-item {
  display: flex;
}
.gjhBox {
  flex-shrink: 0;
}
.gjhBox /deep/.el-textarea__inner {
  width: 150px;
  height: 60px;
}

.margin0 {
  margin: 0 !important;
}
.red {
  color: #ff0000;
  font-size: 14px;
  margin: 0 4px;
  font-family: Source Han Sans CN;
}
.el-dialog .el-dialog__body {
  padding: 10px 20px;
}
.el-input.is-disabled .el-input__inner {
  border: none;
  background: #dcedff;
}

// 按钮样式
.el-button--primary {
  background-color: #0e6eec;
}
.el-button--primary:focus,
.el-button--primary:hover {
  background: #0b59bd;
  border-color: #0b59bd;
  color: #fff;
}
.el-button {
  padding: 7px 15px;
}
.el-button--text {
  padding: 0;
}
.bigBtn {
  padding: 12px 28px;
}
.el-button--text {
  color: #0e6eec;
}
.el-button--text:focus,
.el-button--text:hover {
  color: #0b59bd;
}
// 表格样式
.el-table th {
  background-color: #f5f5f5;
  height: 40px;
  color: #333333;
}
.el-table {
  color: #333;
}
.el-table tr {
  height: 32px;
}
.el-table tr:nth-child(even) {
  background-color: #f8fafd;
}
.el-table__body tr.hover-row > td {
  background-color: rgba(14, 110, 236, 0.3) !important;
}
.el-table__body tr.current-row > td {
  background-color: rgba(14, 110, 236, 0.3) !important;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(14, 110, 236, 0.3) !important;
}
// .el-table__body tr:hover {
//   background-color: rgba(14, 110, 236, 0.3) !important;
// }
.el-table .cell {
  text-align: center;
}

//表单颜色
.el-form-item__label {
  color: #333;
}
// 弹框样式
.el-message-box__header {
  border-bottom: 1px solid #dcdfe6;
}
.el-message-box__title {
  font-size: 16px;
  color: #333;
}
.el-message-box__content {
  color: #333;
}
.el-dialog__headerbtn {
  top: 12px;
  .el-dialog__close {
    color: #fff;
  }
}
.el-dialog__title {
  color: #fff;
}
.el-dialog__header {
  padding: 8px 20px;
  background-color: #0e6eec;
  border-radius: 4px 4px 0 0;
}
.el-dialog--center {
  border-radius: 4px 4px 0 0;
}
//发布货源
.addressBox {
  .title {
    margin-top: 0;
    margin-left: 10px;
    font-size: 16px;
    .iconFont {
      color: #0e6eec;
    }
  }
  .el-button--text {
    padding: 0;
    margin: 0 4px;
  }
}
hr {
  width: 100%;
  height: 1px;
  border: none;
  border-top: dashed 1px #dcdfe6;
}
.el-form--inline .diqu {
  display: flex;
  .el-form-item__content {
    display: flex;
    flex-direction: column;
    .el-input__inner {
      width: 240px;
    }
  }
}
.iconFont {
  margin-right: 4px;
  font-size: 14px;
}
.el-date-editor.el-input {
  width: auto;
}
.inpBox .el-date-editor .el-input__inner {
  width: 180px;
}
.el-upload--picture-card {
  background-image: url(../../../assets/images/upload.png);
  background-size: 150%;
  background-position: 50% 50%;
}
.disabled .el-input__inner {
  background: #dcedff;
}
// 详情页title
.detailsTitle {
  display: flex;
  justify-content: space-between;
  padding-right: 10px 10px;
  margin-left: 10px;
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 10px;
  h4 {
    margin: 0;
    font-size: 16px;
    color: #333;
    padding-bottom: 10px;
    border-bottom: 2px solid #0e6eec;
  }
  .printBox h4 {
    display: inline-block;
    margin-right: 20px;
  }
  .fa-reply {
    padding-right: 10px;
    color: #0e6eec;
  }
}
body.el-loading-parent--relative {
  position: static !important;
}
.mar10 {
  margin-left: 10px;
}
// 提单详情
.ydxq {
  display: flex;
  color: #fff;
  background: #4894f6;
  margin: 0;
  flex-wrap: wrap;
  padding-left: 10px;
}
// 抽屉样式
.el-drawer__header {
  height: 40px;
  background: #0e6eec;
  padding: 0 0 0 10px;
  color: #fff;
  margin: 0;
}
.el-drawer__body {
  overflow: auto;
  padding-bottom: 48px;
}
.footerBox {
  text-align: center;
  position: absolute;
  bottom: 0px;
  width: 100%;
  padding: 10px;
  background: #fff;
}
.leftDrawer {
  width: 50%;
}
.rightDrawer {
  width: 50%;
  right: 0;
  left: auto;
}
.BtnBox {
  display: flex;
  margin: 10px;
  .el-button {
    margin-left: 8px;
  }
}
.el-table--mini,
.el-table--small,
.el-table__expand-icon {
  font-size: 14px;
}
// 表格错位问题
body .el-table th.gutter:last-of-type {
  display: block !important;
  width: 17px !important;
}
// 运单的车辆监控
.vehm .el-dialog__body {
  padding: 0;
}
.amap-icon img {
  width: 32px;
  height: 32px;
}
.amap-sug-result {
  z-index: 999999;
}
.is-need:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.el-table__empty-block {
  align-items: stretch !important;
}
.el-cascader-node > .el-radio {
  visibility: hidden !important;
}
.detail .box1 span {
  font-size: 14px !important;
}
.detail .el-date-editor .el-input__inner {
  font-size: 14px !important;
}
.timmHH .el-time-panel {
  //解决时间选择器需要选择到时
  display: none;
}
.boundStyle .el-form-item--mini.el-form-item {
  margin-bottom: 20px !important;
}
</style>
